import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BootcampDurationIcon: React.FC<SVGComponentProps> = ({
  width = 26,
  height = 26
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.2" y="0.2" width="25.6" height="25.6" rx="3.8" fill="white" />
      <rect
        x="0.2"
        y="0.2"
        width="25.6"
        height="25.6"
        rx="3.8"
        stroke="#E2E8F0"
        strokeWidth="0.4"
      />
      <g clipPath="url(#clip0_1264_31458)">
        <path
          d="M13.0013 9.50001V13L15.3346 14.1667M18.8346 13C18.8346 16.2217 16.223 18.8333 13.0013 18.8333C9.77964 18.8333 7.16797 16.2217 7.16797 13C7.16797 9.77834 9.77964 7.16667 13.0013 7.16667C16.223 7.16667 18.8346 9.77834 18.8346 13Z"
          stroke="#7F1D1D"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1264_31458">
          <rect width="14" height="14" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);

export { BootcampDurationIcon };
